/* Ported from the WP "coaching" theme main.js. WooCommerce AJAX code removed; cart logic lives in cs-cart.js / cs-product.js. */
document.addEventListener('DOMContentLoaded', function() {
    const mobileToggle = document.querySelector('.mobile-toggle');
    const nav = document.querySelector('.nav');
    
    // Create overlay
    const overlay = document.createElement('div');
    overlay.classList.add('nav-overlay');
    document.body.appendChild(overlay);
    
    function toggleMenu() {
        mobileToggle.classList.toggle('active');
        nav.classList.toggle('open');
        overlay.classList.toggle('active');
        document.body.classList.toggle('menu-open');
        
        const isOpen = mobileToggle.classList.contains('active');
        mobileToggle.setAttribute('aria-expanded', isOpen);
    }
    
    mobileToggle.addEventListener('click', toggleMenu);
    overlay.addEventListener('click', toggleMenu);
    
    // Close menu on link click (for mobile)
    const navLinks = nav.querySelectorAll('a');
    navLinks.forEach(link => {
        link.addEventListener('click', function() {
            if (window.innerWidth <= 1200) {
                // Only close if not a sub-menu toggle
                if (!this.parentElement.classList.contains('menu-item-has-children')) {
                    if (nav.classList.contains('open')) {
                        toggleMenu();
                    }
                }
            }
        });
    });
    
    // Close menu on window resize
    window.addEventListener('resize', function() {
        if (window.innerWidth > 1200 && nav.classList.contains('open')) {
            toggleMenu();
        }
    });
});

document.addEventListener('DOMContentLoaded', function () {

    // Accordion functionality
    document.querySelectorAll('.accordion-header').forEach(function (header) {
        header.addEventListener('click', function () {
            var item = header.parentElement;
            var isActive = item.classList.contains('active');

            // Close all items
            document.querySelectorAll('.accordion-item').forEach(function (i) {
                i.classList.remove('active');
            });

            // Open clicked item if it wasn't active
            if (!isActive) {
                item.classList.add('active');
            }
        });
    });

    // FAQ functionality
    document.querySelectorAll('.faq-question').forEach(function (question) {
        question.addEventListener('click', function () {
            var item = question.parentElement;
            item.classList.toggle('active');
        });
    });

    // Blog Slider
    if (jQuery('.blog-slider').length) {
        jQuery('.blog-slider').slick({
            dots: false,
            infinite: true,
            speed: 500,
            slidesToShow: 3,
            nextArrow:jQuery('.slider-prev'),
            prevArrow:jQuery('.slider-next'),
            slidesToScroll: 1,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        });
    }
    jQuery('.testimonials-grid').slick({
        dots: false,
        infinite: true,
        speed: 500,
        arrows: false,
        slidesToScroll: 1,
        autoplay:true,
        variableWidth: true,
        responsive:[
             {
            breakpoint: 800,
            settings: {
                slidesToShow: 1,
                variableWidth: false,
            }
            },
        ]
    });
    jQuery('a[href="#build-your-kit"]').on('click', function(e){ e.preventDefault();
        jQuery('html, body').animate({
            scrollTop: jQuery("#build-your-kit").offset().top - 50
        }, 1000); 
    });
    jQuery('.calculator-tab').on('click', function() {
        jQuery('.calculator-tab').removeClass('active');
        jQuery(this).addClass('active');
    });

    // Smooth scroll to the online-course pricing form
    jQuery('a[href="#priceform"]').on('click', function(e) {
        e.preventDefault();
        jQuery('html, body').animate({ scrollTop: jQuery("#priceform").offset().top - 100 }, 1000);
    });

    // Mobile: tap a parent menu item to open its sub-menu
    document.querySelectorAll('.nav .menu-item-has-children > a').forEach(function (a) {
        a.addEventListener('click', function (e) {
            if (window.innerWidth <= 992) {
                var li = a.parentElement;
                if (!li.classList.contains('submenu-open')) {
                    e.preventDefault();
                    li.classList.add('submenu-open');
                }
            }
        });
    });
});
